import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import { Lightbulb } from "lucide-react";
import React from "react";
import { Flex } from "..";
import Alert from "./Alert";

type Story = ComponentStory<typeof Alert>;

const commonArgs: React.ComponentProps<typeof Alert> = {
    action: {
        onClick: action("clicked"),
        title: "View changes",
        trackName: ""
    },
    badgeText: "New feature",
    color: "heads-up",
    layout: "default",
    onClose: action("closed"),
    onCloseTrackName: "Test",
    supportingText: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    text: "We've just released a new feature",
    type: "badge-group"
};

export default {
    title: "common/Alert",
    component: Alert,
    args: commonArgs
} as ComponentMeta<typeof Alert>;

const Template: Story = props => <Alert {...props} />;

export const DefaultBadgeGroup = Template.bind({});

export const BadgeGroupWithoutCloseButton = Template.bind({});
BadgeGroupWithoutCloseButton.args = {
    onClose: undefined,
    onCloseTrackName: undefined
};

export const BadgeGroupWithoutActions = Template.bind({});
BadgeGroupWithoutActions.args = {
    action: undefined
};

export const BadgeGroupWithoutActionsAndSupportingText = Template.bind({});
BadgeGroupWithoutActionsAndSupportingText.args = {
    action: undefined,
    supportingText: undefined
};

export const BadgeGroupWithoutActionsAndCloseButton = Template.bind({});
BadgeGroupWithoutActionsAndCloseButton.args = {
    action: undefined,
    onClose: undefined,
    onCloseTrackName: undefined
};

export const BadgeGroupWithoutActionsAndSupportingTextAndCloseButton = Template.bind({});
BadgeGroupWithoutActionsAndSupportingTextAndCloseButton.args = {
    action: undefined,
    onClose: undefined,
    onCloseTrackName: undefined,
    supportingText: undefined
};

export const CompactBadgeGroupWithoutCloseButton = Template.bind({});
CompactBadgeGroupWithoutCloseButton.args = {
    layout: "compact",
    onClose: undefined,
    onCloseTrackName: undefined
};

export const CompactBadgeGroupWithoutCloseButtonAndActions = Template.bind({});
CompactBadgeGroupWithoutCloseButtonAndActions.args = {
    layout: "compact",
    onClose: undefined,
    onCloseTrackName: undefined,
    action: undefined
};

export const DefaultTextAlert = Template.bind({});
DefaultTextAlert.args = {
    type: "text"
};

export const TextAsANodeAlert = Template.bind({});
TextAsANodeAlert.args = {
    type: "text",
    text: (
        <Flex gap={8} column>
            <span>We've just released a new feature</span>
            <span>And it's awesome</span>
        </Flex>
    ),
    supportingText: undefined
};

export const TextAlertWithoutActions = Template.bind({});
TextAlertWithoutActions.args = {
    type: "text",
    action: undefined
};

export const TextAlertWithoutActionsAndSupportingText = Template.bind({});
TextAlertWithoutActionsAndSupportingText.args = {
    type: "text",
    action: undefined,
    supportingText: undefined
};

export const CompactTextAlert = Template.bind({});
CompactTextAlert.args = {
    type: "text",
    layout: "compact"
};

export const CompactTextAlertWithoutActions = Template.bind({});
CompactTextAlertWithoutActions.args = {
    type: "text",
    layout: "compact",
    action: undefined
};

export const CompactTextAlertWithoutActionsAndSupportingText = Template.bind({});
CompactTextAlertWithoutActionsAndSupportingText.args = {
    type: "text",
    layout: "compact",
    action: undefined,
    supportingText: undefined
};

export const CompactTextAlertWithCustomIcon = Template.bind({});
CompactTextAlertWithCustomIcon.args = {
    type: "text",
    layout: "compact",
    icon: (
        <Flex backgroundColor="tertiary-600" borderRadius="50%" color="background-primary-base" p={12}>
            <Lightbulb />
        </Flex>
    )
};
